import dashboardConfig from '@/modules/dashboard/config'
import request from '@/modules/base/util/request'

/*
 * Actions
 */
const START_FETCHING_STATS_DATA = 'orgamax/dashboard/topSalesStats/START_FETCHING_STATS_DATA'
const FINISHED_FETCHING_STATS_DATA = 'orgamax/dashboard/topSalesStats/FINISHED_FETCHING_STATS_DATA'
const ERROR_FETCHING_STATS_DATA = 'orgamax/dashboard/topSalesStats/ERROR_FETCHING_STATS_DATA'

/*
 * Reducer
 */
const initialState = {
  isLoading: true,
  errorOccurred: false,
  statsData: {},
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case START_FETCHING_STATS_DATA:
      return Object.assign({}, state, {
        isLoading: true,
      })

    case FINISHED_FETCHING_STATS_DATA:
      const { statsData } = action
      return Object.assign({}, state, {
        isLoading: false,
        errorOccurred: false,
        statsData,
      })

    case ERROR_FETCHING_STATS_DATA:
      return Object.assign({}, state, {
        isLoading: false,
        errorOccurred: true,
      })

    default:
      return state
  }
}

/*
 * Action Creators
 */
const startFetchingStatsData = () => {
  return {
    type: START_FETCHING_STATS_DATA,
  }
}

const finishedFetchingStatsData = statsData => {
  return {
    type: FINISHED_FETCHING_STATS_DATA,
    statsData,
  }
}

const errorFetchingStatsData = () => {
  return {
    type: ERROR_FETCHING_STATS_DATA,
  }
}

export const fetchStatsData = (dateRange) => {
  return dispatch => {
    dispatch(startFetchingStatsData())

    request(
      `${dashboardConfig.statistic}turnoverCustomersArticlesPeriod?startDate=${dateRange.startDate}&endDate=${dateRange.endDate}`,
      {
        auth: true,
        isConcurrent: true,
      },
    )
      .then(({ body: { data } }) => {
        dispatch(finishedFetchingStatsData(data))
      })
      .catch(() => {
        dispatch(errorFetchingStatsData())
      })
  }
}
